/**************************************************************************************************/
/*   File: /src/app/shared/enums/local.document.status.enum.ts                                    */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Tuesday February 19th 2019                                                     */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Fri Feb 22 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
/**
 * Local document status enumeration
 */
export enum LocalDocumentStatusEnum {
    /**
     * Local document exists and is locked by someone
     */
    EXISTS_AND_LOCK = 1,
    /**
     * Local document exists and is unlocked
     */
    EXISTS_AND_UNLOCK = 2,
    /**
     * Local document not exists
     */
    NOT_EXISTS = 3
}